const config = {
    API_URL: process.env.REACT_APP_MX_API_URL,
    MX_API_URL: process.env.REACT_APP_MX_API_URL,
    MX_LIVE_URL: process.env.REACT_APP_MX_LIVE_URL
};
export default config;
